module.exports = __webpack_public_path__ + "static/bb-bg-b1b97ded7d4345fc70d5889bf03c026f.png";